import { Star } from 'lucide-react';

/**
 * FounderBadge — the "Genesis · Founder" pill shown next to Genesis's name
 * on posts and comments inside the Fellowship Channel.
 *
 * Variant A (gold pill), soft warm gradient with a small star icon.
 */
export function FounderBadge({ compact = false }) {
  return (
    <span
      className="inline-flex items-center gap-1 rounded-full flex-shrink-0"
      style={{
        background: 'linear-gradient(135deg, #F3D97C 0%, #E8C265 100%)',
        color: '#3B2F14',
        fontFamily: 'Manrope, sans-serif',
        fontWeight: 700,
        fontSize: compact ? '9.5px' : '10.5px',
        letterSpacing: '0.06em',
        textTransform: 'uppercase',
        padding: compact ? '2px 7px' : '3px 9px',
        border: '1px solid #D9B14A',
        boxShadow: '0 1px 2px rgba(139,102,20,0.2)',
      }}
      data-testid="founder-badge"
      title="Genesis · Founder"
    >
      <Star className="w-3 h-3" fill="#3B2F14" strokeWidth={0} />
      <span>Genesis · Founder</span>
    </span>
  );
}

export default FounderBadge;
